import { mapState } from 'vuex'

export default {
  // Mixin for financial services forms
  // Required data property: infoText

  props: {
    isReadOnly: {
      type: Boolean,
      required: true,
    },
    financialParams: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  inject: ['retrieveText', 'retrieveModalText', 'retrieveInfoText'],
  emits: ['updateFinancing'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapState('quote', ['quote']),
  },
  methods: {
    handleChangeParam(e, paramKey = null) {
      const value = e?.target?.value || e
      paramKey = paramKey || e?.target?.id
      const param = this.financialParams[paramKey] || null
      if (typeof value !== 'undefined' && param) {
        let newVal = parseInt(value)
        if (newVal < param.min) newVal = param.min
        if (newVal > param.max) newVal = param.max
        if (param.step) newVal -= newVal % param.step
        this.$emit('updateFinancing', paramKey, newVal)
      }
    },
    closeInfoModal(infoTextKey) {
      this.infoText[infoTextKey].show = false
    },
  },
}
